import React from 'react';
import PropTypes from 'prop-types';
import s from './UnitCompanionServiceLogList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';

const UnitCompanionServiceLogListTable = ({ paginatedData = [], currentTimezone }) => {
  const formatDateTime = value =>
    value
      ? moment
          .unix(value)
          .tz(currentTimezone)
          .format('DD-MMM-YYYY HH:mm:ss z')
      : '-';

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="maintenance.companionServiceLog.unit" defaultMessage="Unit" />
            </th>
            <th>
              <FormattedMessage id="maintenance.companionServiceLog.started" defaultMessage="Started" />
            </th>
            <th>
              <FormattedMessage id="maintenance.companionServiceLog.ended" defaultMessage="Ended" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="maintenance.companionServiceLog.endedBy" defaultMessage="Ended By" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="maintenance.companionServiceLog.procedures" defaultMessage="Procedures" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => (
            <tr key={n.UnitGuidedServiceSessionId}>
              <td>{n.UnitName || ''}</td>
              <td>{formatDateTime(n.StartedAt)}</td>
              <td>{formatDateTime(n.EndedAt)}</td>
              <td className="d-none d-md-table-cell">{n.EndedBy || ''}</td>
              <td className="d-none d-md-table-cell">{n.ProcedureCount ?? 0}</td>
              <td>
                <Link to={`/maintenance/companionservicelog/${n.UnitGuidedServiceSessionId}`}>
                  <Button variant="outline-secondary">
                    <FormattedMessage id="maintenance.companionServiceLog.view" defaultMessage="VIEW" />
                  </Button>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

UnitCompanionServiceLogListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(UnitCompanionServiceLogListTable);
